/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesArenaGamePlacementSchema } from "./arenaGamePlacementSchema.ts";
import { goodLuckCoreEntitiesArenaGameStatusSchema } from "./arenaGameStatusSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesArenaGameSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  gameNumber: z.optional(z.int()),
  get status() {
    return goodLuckCoreEntitiesArenaGameStatusSchema.optional();
  },
  lobbyHostUserId: z.string().nullish(),
  riotGameId: z.string().nullish(),
  lcuRawJson: z.string().nullish(),
  playersJson: z.string().nullish(),
  startedAtUtc: z.iso.datetime().nullish(),
  completedAtUtc: z.iso.datetime().nullish(),
  createdAt: z.optional(z.iso.datetime()),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get placements() {
    return z.array(goodLuckCoreEntitiesArenaGamePlacementSchema).nullish();
  },
});
